// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KLd7w","comment":"styles_comment__2c8n9"};